import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import {PageView, initGA} from '../../features/Tracking';
import { withTranslation } from 'react-i18next';

class Newsletter extends React.Component {

    componentDidMount() {
        const { t } = this.props;
        initGA();
        PageView();
        document.title = t('pages.newsletter.title');
    }

    render() {
        const { t } = this.props;
        window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            event: 'Pageview',
            'pageUrl': window.location,
            'pageTitle' : window.title
            });

        return(
            <div className="App Newsletter">
                <Header hide="false" hideSearch={true} />
                    <main>
                    <h1>{t('pages.newsletter.title')}</h1>
                    <img style={{maxWidth:'300px', display:'block',  margin:'0 auto'}} width='60%' src='/images/partners/imaclub/imaclub-logo.png'></img>
                    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdWh8Rug_An2gkaCU3kdv4-TqN2QPvv8AaReS8Y6FIw_FEOoQ/viewform?embedded=true" width="1024" height="1250" frameborder="0" marginheight="0" marginwidth="0">בטעינה…</iframe>
                </main>
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Newsletter);